import React from 'react'
import { PrismicLink } from '@prismicio/react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const CategoryList = ({ item }) => {
  const itemData = item.node.data
  const authorData = itemData.author[0].author_link.document.data
  const publishDate = item.node.first_publication_date_formatted

  return (
    <li className='space-y-10'>
      <PrismicLink href={item.node.url}>
        <article className='relative isolate flex flex-col gap-4 lg:flex-row'>
          <div className='w-full'>
            <div className='group relative max-w-xl'>
              <h3 className='text-lg leading-6 text-indigo-600 group-hover:text-gray-600 dark:text-gray-50 dark:group-hover:text-indigo-400'>
                <span className='absolute inset-0' />
                {itemData.blogpost_title.text}
              </h3>
            </div>
            {authorData.page_title && (
              <div className='mt-2 flex border-t border-gray-900/5 pt-2'>
                <div className='relative flex items-center gap-x-3'>
                  <GatsbyImage
                    className='border-1 border-1 h-8 w-8 rounded rounded-bl-none border-white border bg-gray-50'
                    image={authorData.page_image.gatsbyImageData}
                    alt={authorData.page_image.alt || ''}
                  />
                  <div className='leading-6'>
                    <p className='font-medium'>
                      <span className='absolute inset-0' />
                      {authorData.page_title.text}
                    </p>
                    <time dateTime={publishDate} className='text-sm text-gray-500 dark:text-gray-50'>
                      {publishDate}
                    </time>
                  </div>
                </div>
              </div>
            )}
          </div>
          {itemData.blogpost_image.url && (
            <div className='relative aspect-[16/9] sm:aspect-[2/1] lg:aspect-square lg:h-20 lg:w-20 lg:shrink-0'>
              <GatsbyImage className='absolute inset-0 h-full w-full rounded-2xl bg-gray-50 object-cover' image={getImage(itemData.blogpost_image)} alt={itemData.blogpost_image.alt || ''} />
            </div>
          )}
        </article>
      </PrismicLink>
    </li>
  )
}

export default CategoryList
